import z from 'zod'
import { http } from './http'
import { auth } from './auth'
import { ClosingVersionSchema } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'

type PushToDmsPayload = {
  folder_id: string
  workspace_id?: number
  format: string
  filename: string
}

const ClosingVersionResponseSchema = z.object({
  closing_version: ClosingVersionSchema,
})

export const closingVersions = {
  get: async (closingVersionId: number, dealId?: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(
      `${regionHost}/api/closing_versions/${closingVersionId}`,
      undefined,
      dealId,
    )
    return parseWithZod(ClosingVersionResponseSchema, result).closing_version
  },

  pushToDms: async (closingVersionId: number, payload: PushToDmsPayload, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/closing_versions/${closingVersionId}/push_to_dms`,
      payload,
      dealId,
    )
    return parseWithZod(ClosingVersionResponseSchema, result).closing_version
  },
}
